(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tsb-blend-explorer"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('tsb-blend-explorer')) {
  customElements.define('tsb-blend-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[data-be-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-be-panel]'));
      const tablist = this.querySelector('[data-be-tabs]');
      if (!tablist || !this.tabs.length) return;
      tablist.hidden = false;
      tablist.setAttribute('role', 'tablist');
      this.tabs.forEach((tab) => tab.setAttribute('role', 'tab'));
      this.panels.forEach((panel) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', panel.id.replace('BlendPanel-', 'BlendTab-'));
        panel.tabIndex = 0;
      });
      this.select(this.tabs.find((tab) => tab.dataset.blend === this.dataset.firstBlend) || this.tabs[0]);
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-be-tab]');
        if (tab && this.tabs.includes(tab)) this.select(tab);
      }, options);
      this.addEventListener('keydown', (event) => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(this.tabs[next]);
        this.tabs[next].focus();
      }, options);
      document.addEventListener('shopify:block:select', (event) => {
        if (!this.contains(event.target)) return;
        const tab = this.tabs.find((item) => item.dataset.beTab === event.detail.blockId);
        if (tab) this.select(tab);
      }, options);
    }
    select(selected) {
      this.tabs.forEach((tab) => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => { panel.hidden = panel.dataset.bePanel !== selected.dataset.beTab; });
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsb-product-blends"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('tsb-blend-explorer')) {
  customElements.define('tsb-blend-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[data-be-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-be-panel]'));
      const tablist = this.querySelector('[data-be-tabs]');
      if (!tablist || !this.tabs.length) return;
      tablist.hidden = false;
      tablist.setAttribute('role', 'tablist');
      this.tabs.forEach((tab) => tab.setAttribute('role', 'tab'));
      this.panels.forEach((panel) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', panel.id.replace('BlendPanel-', 'BlendTab-'));
        panel.tabIndex = 0;
      });
      this.select(this.tabs.find((tab) => tab.dataset.blend === this.dataset.firstBlend) || this.tabs[0]);
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-be-tab]');
        if (tab && this.tabs.includes(tab)) this.select(tab);
      }, options);
      this.addEventListener('keydown', (event) => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(this.tabs[next]);
        this.tabs[next].focus();
      }, options);
      document.addEventListener('shopify:block:select', (event) => {
        if (!this.contains(event.target)) return;
        const tab = this.tabs.find((item) => item.dataset.beTab === event.detail.blockId);
        if (tab) this.select(tab);
      }, options);
    }
    select(selected) {
      this.tabs.forEach((tab) => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => { panel.hidden = panel.dataset.bePanel !== selected.dataset.beTab; });
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
